import React from 'react';
import { Badge, Table } from 'react-bootstrap';
import _ from 'lodash';
import classNames from 'classnames';
import moment from 'moment';
const getCellStyle = (isChanged, isPrev) => {
  if (isChanged) {
    return {
      backgroundColor: '#ECECE9'
    };
  } else if (isPrev) {
    return {
      backgroundColor: '#DA252D',
      color: '#fff'
    };
  }
  return null;
};

const getTableBody = (products, offset) => {
  return products.map((item, index) => {
    let cells = _.map(item, (vObj, key) => {
      return (
        <td key={key} style={getCellStyle(vObj.isChanged, vObj.isPrev)}>
          {vObj.value}
        </td>
      );
    });
    return (
      <tr key={index}>
        <td className="tableIndex">{offset + index + 1}</td>
        {cells}
      </tr>
    );
  });
};

const getTableHead = (product = {}) => {
  let tHeads = _.map(product, (vObj, key) => {
    let tableHeadingClassNames = classNames({
      homePageType: key === 'Secondary Menu List',
      brandPageType: key === 'Description',
      productType: key === 'Product Description',
      reviews: key === 'Reviews',
      brandDis: key === 'Brand Description'
    });
    return (
      <th className={tableHeadingClassNames} key={key}>
        {key}
      </th>
    );
  });
  return (
    <tr>
      <th className="tableIndex"> </th>
      {tHeads}
    </tr>
  );
};

const PreviousProductView = props => {
  const { products, previousProductDate, offset, count, perPage } = props;
  if (_.isEmpty(products)) {
    return (
      <p className="alert alert-info">No product(s) from previous file.</p>
    );
  }
  let showingStr = '';
  if (count < offset + perPage) {
    showingStr = `Showing ${offset + 1} - ${count} rows`;
  } else {
    showingStr = `Showing ${offset + 1} - ${offset + perPage} rows`;
  }

  return (
    <div>
      <div className="po-previous-products-col-header">
        <label> Previous </label>
        <Badge>
          {' '}
          {previousProductDate
            ? moment(new Date(`${previousProductDate}`)).format('MM/DD/YYYY')
            : 'N/A'}{' '}
        </Badge>
        <Badge className="po-num-of-rows">{count} Rows</Badge>
        <Badge className="po-badge">{showingStr}</Badge>
      </div>
      <div id="rightDiv" className="po-previous-products-table-wrap">
        <Table bordered condensed hover>
          {/* <thead>{getTableHeadChar(products[0])}</thead> */}
          <thead>{getTableHead(products[0])}</thead>
          <tbody>{getTableBody(products, offset)}</tbody>
        </Table>
      </div>
    </div>
  );
};

export default PreviousProductView;
